import * as React from 'react';
import MuiButton, { ButtonProps as MuiProps } from '@material-ui/core/Button';
import styled from 'styled-components';
import Icon from 'components/Icon';

export const BaseButton = styled(MuiButton).attrs(() => ({
  color: 'inherit',
}))`
  && {
    border-radius: 14px;
    height: 48px;
    box-shadow: none;
  }
`;

export interface ButtonProps extends Partial<MuiProps> {
  isLoading?: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  isLoading = false,
  children,
  ...muProps
}): React.ReactElement => {
  return (
    // FIXME: open issue with MU https://github.com/mui-org/material-ui/pull/21552
    // @ts-ignore
    <StyledButton {...muProps}>
      {isLoading ? <CustomIcon name="spinner" size={20} /> : children}
    </StyledButton>
  );
};

export default Button;

const StyledButton = styled(BaseButton)<MuiProps>`
  && {
    background-color: ${({ theme }) => theme.colors.primary.lightMobile};
    font-family: ${({ theme }) =>
      theme.dir === 'rtl' ? ' Assistant' : 'inherit'};
    color: white;
    min-width: 115px;
    align-self: center;
    text-transform: none;

    &:hover {
      background-color: #a50a0a;
      transition: background-color 0.3s;
      box-shadow: none;
    }

    &:disabled {
      background-color: #e8e8e8;
      color: white;
    }
  }
`;

export const CustomIcon = styled(Icon).attrs<{ $secondary?: boolean }>(
  ({ theme, $secondary }) => ({
    color: $secondary
      ? theme.colors.primary.light
      : theme.colors.primary.contrastText,
  })
)`
  ${({ theme }) => theme.utils.spinAnimation};
  position: absolute;
  top: 50%;
  left: 50%;
`;
